import { Drawer } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleMobileSidebar } from "../../../../feature/sidebar/sidebarSlice";
import SidebarItems from "../SidebarItems";

const drawerWidth = 260;

const MobileDrawer = (props) => {
  const { isMobileOpen } = useSelector((state) => state.sidebar);
  const { window } = props;
  const dispatch = useDispatch();

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Drawer
      container={container}
      variant='temporary'
      open={isMobileOpen}
      onClose={() => {
        dispatch(toggleMobileSidebar());
      }}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
      sx={{
        display: { xs: "block", md: "none" },
        "& .MuiDrawer-paper": {
          marginTop: "65px",
          paddingTop: "45px",
          paddingBottom: "80px",
          width: drawerWidth,
          overflowY: "auto",
          boxShadow: "0 0.5rem 1rem 0 rgb(44 51 73 / 10%)",
          scrollbarWidth: "thin",
          "&::-webkit-scrollbar": {
            width: "0.4em",
          },
          "&::-webkit-scrollbar-track": {
            boxShadow: "0 0.5rem 1rem 0 rgb(44 51 73 / 10%)",
            webkitBoxShadow: "0 0.5rem 1rem 0 rgb(44 51 73 / 10%)",
            backgroundColor: "scrollbar.secondary",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "scrollbar.primary",
            borderRadius: "3rem",
          },
        },
      }}
    >
      <SidebarItems />
    </Drawer>
  );
};

export default MobileDrawer;
